const API_BASE = (process.env.REACT_APP_API_URL || "/backend").replace(/\/$/, "");

const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    Number(n) || 0
  );

function assetUrl(path) {
  if (!path) return `${API_BASE}/assets/img/placeholder.svg`;
  if (path.startsWith("http")) return path;
  // Already absolute under /backend/...
  if (path.startsWith("/backend/")) return path;
  if (path.startsWith("/assets/")) return `${API_BASE}${path}`;
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

function normalizeProduct(p) {
  return { ...p, image: assetUrl(p.image) };
}

async function api(path, options = {}) {
  const url = path.startsWith("http")
    ? path
    : `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
  const res = await fetch(url, {
    headers: { Accept: "application/json", "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    throw new Error(json.error || `Request failed (${res.status})`);
  }
  return json.data;
}

export const getStore = () => api("/api/store.php");
export const getCategories = () => api("/api/categories.php");
export const getContents = () => api("/api/content.php");
export const getContentMap = async () => {
  const list = await getContents();
  return Object.fromEntries((list || []).map((s) => [s.section_key, s]));
};
export const getProducts = async (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.set(k, v);
  });
  const qs = q.toString();
  const data = await api(`/api/products.php${qs ? `?${qs}` : ""}`);
  return Array.isArray(data) ? data.map(normalizeProduct) : normalizeProduct(data);
};
export const getProduct = async (slug) =>
  normalizeProduct(await api(`/api/products.php?slug=${encodeURIComponent(slug)}`));
export const placeOrder = (payload) =>
  api("/api/orders.php", { method: "POST", body: JSON.stringify(payload) });
export const sendContact = (payload) =>
  api("/api/contact.php", { method: "POST", body: JSON.stringify(payload) });

export { money, API_BASE, assetUrl };
